export const mapCheckboxStyles = (theme, options) => {
  return {
    root: {
      color: 'var(--color-neutral-500)',
      '&:hover': {
        backgroundColor: 'var(--color-primary-050)'
      },
      '&.Mui-checked': {
        color: 'var(--color-primary-500)'
      },
      '&.Mui-disabled': {
        color: 'var(--color-neutral-300)',
        cursor: 'not-allowed'
      }
    },
    ...options
  }
}
